module.exports = __webpack_public_path__ + "img/20exp.5ff160b1.jpg";